import { inject, Injectable } from '@angular/core';
import { AppContext } from 'src/app/app/context';
import { CustomFields } from './CustomFields';
import { CustomFieldSyntaxVisitor } from './CustomFieldSyntaxVisitor';

@Injectable({ providedIn: 'root' })
export class CustomFieldFunctionResolver {
  readonly appContext = inject(AppContext);

  private map: Map<string, CustomFields.Function>;

  constructor() { }

  readonly resolver: CustomFieldSyntaxVisitor.FunctionResolver = (name, args) => {
    this.ensureMap();

    return this.map.get(name.toLowerCase());
  };

  private createMap() {
    let map = new Map<string, CustomFields.Function>();

    for (let f of this.appContext.customFieldFunctions()) {
      map.set(f.name.toLowerCase(), f);
    }

    return map;
  }

  private ensureMap() {
    if (!this.map)
      this.map = this.createMap();
  }
}